import { Box } from '@mui/material';

import PrivacyPolicyStyle from './style';

import TitlePrivacyPolicyAndTermsAndCondition from '@components/molecules/titlePrivacyPolicyAndTermsAndCondition';
import NextLink from 'src/components/atoms/link';

const PrivacyPolicy = () => (
  <PrivacyPolicyStyle>
    <Box className="container">
      <TitlePrivacyPolicyAndTermsAndCondition isPrivacyPolicy />
      <Box className="paragraph">
        <Box className="bold">1. หลักการ</Box>
        <Box className="indent">
          ศูนย์ฝึกอบรมฯ เคารพสิทธิความเป็นส่วนตัวในข้อมูลส่วนบุคคลของผู้เข้ารับการอบรมฯ
          ทุกท่านที่ใช้บริการผ่านระบบหรือช่องทางการให้บริการจัดอบรมหลักสูตรออนไลน์ฯ ของศูนย์ฝึกอบรมฯ
          หรือตัวแทนของศูนย์ฝึกอบรมฯ และตระหนักในการปกป้องข้อมูลดังกล่าว โดยการปฏิบัติตามนโยบายนี้
        </Box>
        <br />
        <Box className="indent">
          การเข้าถึงหรือการใช้งานผ่านระบบการให้บริการจัดอบรมหลักสูตรการประกันภัยและความรู้ตลาดทุน (แล้วแต่กรณี)
          ผ่านระบบการให้บริการจัดอบรมหลักสูตรออนไลน์ฯ นี้ของศูนย์ฝึกอบรมฯ ถือว่าผู้เข้ารับการอบรมฯ
          ตกลงยอมรับเงื่อนไขของนโยบายคุ้มครองข้อมูลส่วนบุคคลของศูนย์ฝึกอบรมฯ ฉบับนี้
        </Box>
      </Box>

      <Box className="paragraph">
        <Box className="bold">2. คำนิยาม</Box>
        <Box className="indent bold">“กฎหมายคุ้มครองข้อมูลส่วนบุคคล” :</Box>
        <Box className="indent">
          พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 และที่แก้ไขเพิ่มเติม รวมถึงประกาศและระเบียบที่เกี่ยวข้อง
        </Box>
        <br />
        <Box className="indent bold">“ก.ล.ต.” :</Box>
        <Box className="indent">สำนักงานคณะกรรมการกำกับหลักทรัพย์และตลาดหลักทรัพย์</Box>
        <br />
        <Box className="indent bold">“การให้บริการจัดอบรมหลักสูตรออนไลน์ฯ” :</Box>
        <Box className="indent">
          การให้บริการการจัดอบรมหลักสูตรฯ ผ่านระบบทางอิเล็กทรอนิกส์ (e-learning) แก่ผู้เข้ารับการอบรมฯ
          ที่มีสิทธิเข้าอบรม หรือบุคคลที่ใช้บริการ โดยมีข้อกำหนดและเงื่อนไขในการให้บริการเป็นไปตามศูนย์ฝึกอบรมฯ กำหนด
        </Box>
        <br />
        <Box className="indent">
          ทั้งนี้ การให้บริการการอบรมหลักสูตรฯ จะเป็นดำเนินการผ่าน (ก) www.skillLanecpd.com
          และให้หมายความรวมถึงแอพพลิเคชั่นสำหรับการใช้บริการผ่านโทรศัพท์มือถือหรือเครื่องมืออิเล็กทรอนิกส์ หรือ (ข)
          ช่องทางการให้บริการของ SkillLane หรือ (ค) การให้บริการผ่านช่องทางอื่นใดตามที่ศูนย์ฝึกอบรมฯ กำหนด
        </Box>

        <br />
        <Box className="indent bold">“ข้อมูลที่เก็บรวบรวม” :</Box>
        <Box className="indent">
          ข้อมูลส่วนบุคคลที่ศูนย์ฝึกอบรมฯ ดำเนินการเก็บรวบรวม ใช้ หรือเปิดเผยตามที่นโยบายนี้กำหนด
          โดยข้อมูลดังกล่าวจะถูกเก็บรวบรวมโดยอัติโนมัติเมื่อผู้เข้ารับการอบรมฯ ดำเนินการเข้าถึง Log in
          หรือใช้บริการผ่านช่องทางการให้บริการจัดอบรมหลักสูตรออนไลน์ฯ
        </Box>
        <br />
        <Box className="indent bold">“ข้อมูลส่วนบุคคล” :</Box>
        <Box className="indent">
          ข้อมูลเกี่ยวกับบุคคลซึ่งทำให้สามารถระบุตัวบุคคลนั้นได้ไม่ว่าทางตรงหรือทางอ้อม
          รวมถึงข้อมูลอื่นตามที่นโยบายนี้หรือกฎหมายคุ้มครองข้อมูลส่วนบุคคลกำหนด
        </Box>
        <br />
        <Box className="indent bold">“คปภ.” :</Box>
        <Box className="indent">สำนักงานคณะกรรมการกำกับและส่งเสริมการประกอบธุรกิจประกันภัย</Box>
        <br />
        <Box className="indent bold">“ตัวแทนและนายหน้าประกันภัยฯ” :</Box>
        <Box className="indent">
          ตัวแทนประกันชีวิต ตัวแทนประกันวินาศภัย นายหน้าประกันชีวิต และนายหน้าประกันภัย ตามที่กฎหมายกำหนด
          ซึ่งประสงค์จะขอรับและขอต่ออายุใบอนุญาตเป็นตัวแทนและ/หรือนายหน้าประกันวินาศภัยและ/หรือประกันชีวิต (แล้วแต่กรณี)
          โดยการใช้บริการอบรมหลักสูตรผ่านระบบการให้บริการจัดอบรมหลักสูตรออนไลน์ฯ
        </Box>
        <br />
        <Box className="indent bold">“นายจ้างหรือต้นสังกัดฯ” :</Box>
        <Box className="indent">
          นายจ้าง ผู้ว่าจ้างหรือต้นสังกัด ที่ประสงค์ให้และจัดส่งรายชื่อผู้เข้ารับการอบรมฯ
          ในการเข้ารับการอบรมผ่านการให้บริการจัดอบรมหลักสูตรออนไลน์ฯ นี้
        </Box>
        <br />
        <Box className="indent bold">“ผู้เข้ารับการอบรมฯ” :</Box>
        <Box className="indent">
          บุคคลดังต่อไปนี้ (แล้วแต่กรณี) ที่มีคุณสมบัติและได้ลงทะเบียนผ่านระบบการให้บริการจัดอบรมหลักสูตรออนไลน์ฯ
          ที่ศูนย์ฝึกอบรมฯ กำหนดในแต่ละหลักสูตรฯ
        </Box>
        <Box className="indent">(ก) ตัวแทนและนายหน้าประกันภัยฯ สำหรับหลักสูตรอบรมประกันภัย หรือ</Box>
        <Box className="indent">
          (ข) ผู้แนะนำการลงทุน (Investment Consultant) และผู้วางแผนการลงทุน (Investment Planning)
          สำหรับหลักสูตรอบรมตลาดทุน
        </Box>
        <br />
        <Box className="indent bold">“ศูนย์ฝึกอบรมฯ” :</Box>
        <Box className="indent">
          ศูนย์ฝึกอบรม หรือหน่วยงานที่จัดอบรม หรือสถาบันฝึกอบรมดังต่อไปนี้ ซึ่งเป็นผู้จัดอบรมในแต่ละหลักสูตรฯ
          (แล้วแต่กรณี)
        </Box>
        <Box className="indent">
          (ก) หน่วยงานที่จัดอบรมตามที่ คปภ. เห็นชอบ ซึ่ง SkillLane แจ้งให้ทราบ สำหรับหลักสูตรอบรมประกันภัย หรือ
        </Box>
        <Box className="indent">
          (ข) SkillLane ในฐานะที่เป็นสถาบันฝึกอบรมตามที่ TSI ให้ความเห็นชอบ สำหรับหลักสูตรอบรมตลาดทุน
        </Box>
        <br />
        <Box className="indent bold">“หลักสูตรฯ” :</Box>
        <Box className="indent">หลักสูตรเกี่ยวกับ (แล้วแต่กรณี)</Box>
        <Box className="indent">
          (ก) การประกันภัยของผู้ขอรับและขอต่ออายุใบอนุญาตสำหรับเป็นตัวแทนและนายหน้าประกันภัยฯ หรือ
        </Box>
        <Box className="indent">
          (ข) ความรู้ตลาดทุนสำหรับการต่ออายุใบอนุญาตสำหรับผู้แนะนำการลงทุน (Investment Consultant)
          และ/หรือผู้วางแผนการลงทุน (Investment Planning)
        </Box>
        <br />
        <Box className="indent bold">“SkillLane” :</Box>
        <Box className="indent">บริษัท สกิลเลน เอดูเคชั่น จำกัด</Box>
        <br />
        <Box className="indent bold">“TSI” :</Box>
        <Box className="indent">ศูนย์ส่งเสริมการพัฒนาความรู้ตลาดทุน ตลาดหลักทรัพย์แห่งประเทศไทย</Box>
      </Box>

      <Box className="paragraph">
        <Box className="bold">3. ขอบเขต</Box>
        <Box className="indent">
          นโยบายคุ้มครองข้อมูลส่วนบุคคลของศูนย์ฝึกอบรมฯ นี้ ใช้ภายใต้ระบบการให้บริการจัดอบรมหลักสูตรออนไลน์ฯ
          ของศูนย์ฝึกอบรมฯ รวมถึงช่องทางซึ่งสามารถเข้าถึงได้ภายในแพลทฟอร์มในเว็บไซต์นี้ ทั้งนี้
          อาจมีการแสดงข้อกำหนดซึ่งเกี่ยวข้องกับนโยบายคุ้มครองข้อมูลส่วนบุคคลเพิ่มเติมในการให้บริการ
          เพื่อให้ผู้เข้ารับการอบรมฯ อนุมัติก่อนการเข้าถึงบริการนั้นๆ
        </Box>
        <br />
        <Box className="indent">
          ทั้งนี้ ศูนย์ฝึกอบรมฯ ได้จัดเก็บข้อมูลส่วนบุคคคลตามนโยบายคุ้มครองข้อมูลส่วนบุคคลนี้
          จากระบบการให้บริการจัดอบรมหลักสูตรออนไลน์ฯ โดยศูนย์ฝึกอบรมฯ
          จะเก็บรักษาข้อมูลส่วนบุคคลไว้เป็นความลับภายใต้เงื่อนไขที่กำหนดไว้ในนโยบายฉบับนี้ และที่กฎหมายกำหนด
          และศูนย์ฝึกอบรมฯ จะจัดเก็บ รวมรวม ใช้ เปิดเผยและประมวลข้อมูลส่วนบุคคคลของเจ้าของข้อมูล
          โดยได้รับความยินยอมจากเจ้าของข้อมูลด้วยวิธีการตามที่กฎหมายกำหนด
          เว้นแต่กรณีที่กฎหมายกำหนดเงื่อนไขหรือเหตุผลอื่นที่ให้ทำได้โดยไม่ต้องขอความยินยอมจากเจ้าของข้อมูลส่วนบุคคล เช่น
          ฐานการปฏิบัติตามสัญญาในการเข้าทำหรือปฏิบัติตามสัญญาเกี่ยวกับการให้บริการ
          ฐานการปฏิบัติตามกฎหมายเพื่อปฏิบัติหน้าที่ตามกฎหมาย ฐานประโยชน์โดยชอบด้วยกฎหมายของผู้ควบคุมข้อมูล
          ภายใต้เงื่อนไขประโยชน์โดยชอบด้วยกฎหมายของศูนย์ฝึกอบรมฯ ในฐานะผู้ควบคุมข้อมูล ฐานประโยชน์ต่อชีวิต
          เพื่อป้องกันและยับยั้งอันตรายต่อชีวิต ร่างกาย หรือสุขภาพ ฐานประโยชน์สาธารณะ
          เพื่อการปฏิบัติภารกิจเพื่อประโยชน์สาธารณะ หรือเพื่อการใช้อำนาจรัฐ หรือเหตุอื่นที่กฎหมายบัญญัติ เป็นต้น
        </Box>
        <br />
        <Box className="indent">
          การเก็บข้อมูลส่วนบุคคลจากแหล่งอื่นที่ไม่ใช่จากผู้เข้ารับการอบรมฯ โดยตรง ศูนย์ฝึกอบรมฯ
          จะแจ้งการจัดเก็บให้ผู้เข้ารับการอบรมฯ ทราบไม่เกิน 30 วัน หลังจากการจัดเก็บข้อมูล
          เว้นแต่กฎหมายกำหนดให้สามารถเก็บข้อมูลส่วนบุคคลได้รับยกเว้นไม่ต้องขอความยินยอมกฎหมายคุ้มครองข้อมูลส่วนบุคคล
        </Box>
      </Box>
      <Box className="paragraph">
        <Box className="bold">4. วัตถุประสงค์ของการจัดเก็บและการใช้ข้อมูลที่เก็บรวบรวม</Box>
        <Box className="indent">
          นอกเหนือจากวัตถุประสงค์ที่กำหนดไว้ในข้อ 5. ของนโยบายนี้ ศูนย์ฝึกอบรมฯ
          มีความประสงค์จะจัดเก็บรวบรวมและใช้ข้อมูลส่วนบุคคล เพื่อวัตถุประสงค์ดังต่อไปนี้
        </Box>
        <br />
        <Box className="indent">
          • เพื่อนำเสนอหรือเป็นข้อมูลเกี่ยวกับการให้บริการต่างๆ ของศูนย์ฝึกอบรมฯ แก่ผู้เข้ารับการอบรมฯ อาทิ
          การแจ้งรายชื่อผู้มีสิทธิเข้าอบรม การตรวจสอบและแจ้งผลการอบรม การตอบโต้บทสนทนา (Discussion Board)
          การส่งหนังสือรับรองการผ่านการอบรม การติดตามการอบรม การแจ้งเตือนเมื่อใกล้ระยะเวลาที่จะอบรมหลักสูตร แล้วเสร็จ
        </Box>
        <Box className="indent">
          • เพื่อจัดหาและเก็บข้อมูลเกี่ยวกับการให้บริการต่างๆ ของศูนย์ฝึกอบรมฯ ซึ่งผู้เข้ารับการอบรมฯ
          หรือนายจ้างหรือต้นสังกัดฯ หรือ คปภ. หรือ TSI หรือ ก.ล.ต. และหน่วยงานที่เกี่ยวข้องร้องขอ อาทิ
          เพื่อแสดงรายงานการอบรมของผู้เข้ารับการอบรมฯ ให้แก่นายจ้างหรือต้นสังกัดฯ
        </Box>
        <Box className="indent">
          • เพื่อรวบรวมข้อมูลเป็นฐานข้อมูล หรือข้อมูลเชิงสถิติเกี่ยวกับจำนวนผู้เยี่ยมชมเว็บไซต์
          เพื่อนำไปวิเคราะห์หรือเก็บเป็นข้อมูลของศูนย์ฝึกอบรมฯ
        </Box>
        <Box className="indent">
          • เพื่อเป็นช่องทางการติดต่อกับผู้เข้ารับการอบรมฯ เกี่ยวกับการปรับปรุง แก้ไข
          เปลี่ยนแปลงระบบการให้บริการจัดอบรมหลักสูตรออนไลน์ฯ หรือการติดต่อเพื่อขอข้อมูลหรือเอกสารต่างๆ เพิ่มในภายหลัง
        </Box>
        <Box className="indent">
          • เพื่อปฏิบัติตามภาระหน้าที่และตามสิทธิของศูนย์ฝึกอบรมฯ ภายใต้เงื่อนไขตามข้อตกลง (อาทิ ใบสมัครอบรม)
          หรือสัญญาฉบับใดๆ ที่เข้าทำระหว่างผู้เข้ารับการอบรมฯ และ/หรือนายจ้างหรือต้นสังกัดฯ กับศูนย์ฝึกอบรมฯ
        </Box>
        <Box className="indent">
          • เพื่อปฏิบัติตามกฎหมาย หรือกระบวนการทางกฎหมายที่เกี่ยวข้อง
          รวมถึงเพื่อดำเนินการตามการร้องขอของเจ้าหน้าที่ตามกฎหมายหรือทางราชการ
        </Box>
        <Box className="indent">
          • เพื่อการปกป้องหรือประโยชน์ต่อสิทธิ ทรัพย์สิน หรือเพื่อความปลอดภัยของศูนย์ฝึกอบรมฯ และ/หรือผู้เข้ารับการอบรมฯ
          หรือบุคคลอื่น ในกรณีหากศูนย์ฝึกอบรมฯ พิจารณาแล้วเห็นว่าการเก็บรวบรวม ใช้
          หรือเปิดเผยนั้นมีความจำเป็นหรือเหมาะสม
        </Box>
        <br />
        <Box className="indent">
          โดยทางศูนย์ฝึกอบรมฯ จะไม่ใช้ข้อมูลส่วนบุคคลที่ได้รับจากผู้เข้ารับการอบรมฯ
          เพื่อวัตถุประสงค์อื่นใดนอกเหนือจากที่ระบุไว้นโยบายฉบับนี้
          เว้นแต่กฎหมายคุ้มครองข้อมูลส่วนบุคคลหรือกฎหมายอื่นกำหนดเป็นอย่างอื่น
        </Box>
      </Box>
      <Box className="paragraph">
        <Box className="bold">5. ข้อมูลที่เก็บรวบรวม และการนำไปใช้</Box>
        <Box className="indent bold">
          5.1 ชื่อนามสกุล / คำนำหน้า / ที่อยู่ / อีเมล์ (e-mail) / วันเดือนปีเกิด / อายุ / เพศ /
          บัตรประจำตัวประชาชนหรือเลขบัตรประจำตัวประชาชน / เบอร์โทรศัพท์ / การตั้งค่าต่างๆ / ไอพี แอดเดรส (IP Address) /
          ใบสำคัญการเปลี่ยนชื่อหรือสำเนาทะเบียนสมรส
        </Box>
        <Box className="indent bold">วัตถุประสงค์</Box>
        <Box className="indent">• เพื่อตรวจสอบตัวตนของผู้เข้ารับการอบรมฯ</Box>
        <Box className="indent">• เพื่อเป็นข้อมูลสำหรับการใช้บริการและเข้าระบบการให้บริการจัดอบรมหลักสูตรออนไลน์ฯ</Box>
        <Box className="indent">• เพื่อรักษาความปลอดภัยต่อบัญชีผู้เข้ารับการอบรมฯ</Box>
        <Box className="indent">• เพื่อเป็นช่องทางการติดต่อกับผู้เข้ารับการอบรมฯ ในด้านต่างๆ</Box>
        <br />
        <Box className="indent bold">5.2 คุกกี้ (Cookie)</Box>
        <Box className="indent bold">วัตถุประสงค์</Box>
        <Box className="indent">
          • เพื่อเป็นข้อมูลที่อาจเป็นประโยชน์ต่อผู้เข้ารับการอบรมฯ
          ในครั้งถัดไปที่ผู้เข้ารับการอบรมฯกลับมาเยี่ยมชมเว็บไซต์ของศูนย์ฝึกอบรมฯ
        </Box>
        <br />
        <Box className="indent bold">
          5.3 ข้อมูลการอบรม (อาทิ เลขที่ใบอนุญาต วันที่ออกใบอนุญาต สถานะใบอนุญาต วันหมดอายุ ผลการสอบ แบบประเมินการอบรม
          รายละเอียดเกี่ยวกับคุณสมบัติและเอกสารรับรองตามที่ศูนย์ฝึกอบรมฯ และ/หรือ คปภ. กำหนด)
        </Box>
        <Box className="indent bold">วัตถุประสงค์</Box>
        <Box className="indent">
          • เพื่อเป็นการติดตามประวัติ ประสบการณ์ และความคืบหน้า รวมถึงจัดทำข้อมูลในการอบรมหลักสูตรฯ
        </Box>
        <Box className="indent">• เพื่อพิจารณาผลการอบรมและเป็นฐานข้อมูลของศูนย์ฝึกอบรมฯ</Box>
        <Box className="indent">
          • เพื่อเป็นข้อมูลในการอ้างอิง ตรวจ ให้คะแนน และผลการสอบ และออกหนังสือรับรองการผ่านการอบรม
        </Box>
        <br />
        <Box className="indent bold">5.4 ข้อมูลความเห็นที่อยู่ใน Discussion Board</Box>
        <Box className="indent bold">วัตถุประสงค์</Box>
        <Box className="indent">
          • เพื่อเป็นข้อมูลและการตอบข้อสงสัยแก่ผู้เข้ารับการอบรมฯ และการพัฒนาปรับปรุงระบบการให้บริการออนไลน์
        </Box>
        <br />
        <Box className="indent bold">5.5 ข้อมูลการเข้าเยี่ยมชมระบบการให้บริการออนไลน์</Box>
        <Box className="indent bold">วัตถุประสงค์</Box>
        <Box className="indent">• เพื่อเป็นข้อมูลการใช้วิเคราะห์การเข้าใช้งาน การเก็บสถิติของศูนย์ฝึกอบรมฯ</Box>
        <br />
        <Box className="indent bold">5.6 รูปภาพใบหน้า</Box>
        <Box className="indent bold">วัตถุประสงค์</Box>
        <Box className="indent">• เพื่อเป็นการยืนยันตัวตนก่อนและในระหว่างการอบรม</Box>
        <br />
        <Box className="indent bold">5.7 นายจ้างหรือต้นสังกัดฯ</Box>
        <Box className="indent bold">วัตถุประสงค์</Box>
        <Box className="indent">
          • เพื่อเป็นข้อมูลติดต่อและการแจ้งผลการเข้ารับการอบรมของผู้เข้ารับการอบรมฯ รวมถึงส่งข้อมูลต่างๆ
          ให้กับนายจ้างหรือต้นสังกัดฯ สำหรับกรณีที่นายจ้างหรือต้นสังกัด เป็นผู้จัดส่งผู้เข้ารับการอบรมฯ
          เข้ารับการอบรมนี้กับศูนย์ฝึกอบรมฯ
        </Box>
        <br />
        <Box className="indent bold">
          5.8 ข้อมูลและเอกสารประกอบการเข้ารับการอบรม อาทิ
          เอกสารเพื่อยื่นขอในการลดหย่อนชั่วโมงการอบรมสำหรับตัวแทนและนายหน้าประกันภัยฯ (อาทิ วุฒิการศึกษา/
          ข้อมูลการเป็นวิทยากร )
        </Box>
        <Box className="indent bold">วัตถุประสงค์</Box>
        <Box className="indent">
          • เพื่อเป็นข้อมูลสำหรับการพิจารณาการเข้ารับการอบรม อาทิ
          เพื่อยื่นขอในการลดหย่อนชั่วโมงการอบรมหลักสูตรอบรมใบอนุญาตปีที่4 ของตัวแทนและนายหน้าประกันภัยฯ เป็นต้นไป
        </Box>
        <br />
        <Box className="indent">
          การเก็บรวบรวม ใช้ เปิดเผยข้อมูลเกี่ยวกับการเก็บข้อมูลส่วนข้อมูลที่มีความอ่อนไหว (Sensitive Data)
          จะอยู่ภายใต้ความยินยอมของผู้เข้ารับการอบรมฯ ก่อนเท่านั้น
          เว้นแต่เป็นการจัดเก็บข้อมูลตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล
        </Box>
      </Box>
      <Box className="paragraph">
        <Box className="bold">6. การเปิดเผยข้อมูล</Box>
        <Box className="indent">
          ศูนย์ฝึกอบรมฯ อาจเปิดเผยข้อมูลส่วนบุคคลของผู้เข้ารับการอบรมฯ ให้แก่บุคคลดังต่อไปนี้
          ตามวัตถุประสงค์ของนโยบายฉบับนี้
        </Box>
        <br />
        <Box className="indent">• ให้แก่บริษัทย่อย และบริษัทในเครือของศูนย์ฝึกอบรมฯ</Box>
        <Box className="indent">
          • ให้แก่ผู้ซื้อ หรือนักลงทุน หรือผู้สืบสิทธิ หรือสถาบันการเงิน
          หรือบุคคลอื่นที่มีความจำเป็นต้องทราบในกรณีมีการซื้อขายหุ้น ควบรวม การขายกิจการ การกู้ยืมเงินหรือให้กู้เงิน
          การปรับโครงสร้างทั่วไป หรือองค์กร การเลิกกิจการ หรือการขาย หรือโอนลักษณะอื่นซึ่งสินทรัพย์เพียงบางส่วน
          หรือทั้งหมดของศูนย์ฝึกอบรมฯ ไม่ว่าโดยการดำเนินธุรกิจตามปกติ หรือเป็นส่วนหนึ่งของการล้มละลาย การชำระบัญชี
          หรือกระบวนการในทำนองเดียวกันอันเกี่ยวกับระบบการให้บริการจัดอบรมหลักสูตรออนไลน์ฯ
        </Box>
        <Box className="indent">• ให้แก่นายจ้างหรือหน่วยงานต้นสังกัดฯ ของผู้เข้ารับการอบรมฯ</Box>
        <Box className="indent">
          • ให้แก่บุคคลผู้ทำหน้าที่ในการประมวลผลหรือจัดเก็บข้อมูลส่วนบุคคลของศูนย์ฝึกอบรมฯ อาทิ SkillLane
        </Box>
        <Box className="indent">
          • ให้แก่หน่วยงานราชการ
          หรือผู้มีหน้าที่กำกับดูแลหรือผู้ที่จะต้องทราบข้อมูลส่วนบุคคลตามที่กฎหมายคุ้มครองข้อมูลส่วนบุคคลกำหนด อาทิ คปภ.
          TSI และ ก.ล.ต.
        </Box>
        <Box className="indent">
          • ให้แก่บุคคลอื่นใดๆ ซึ่งผู้เข้ารับการอบรมฯ หรือศูนย์ฝึกอบรมฯ แจ้งให้ทราบว่าประสงค์จะเปิดเผย
        </Box>
      </Box>
      <Box className="paragraph">
        <Box className="bold">7. ระยะเวลาในการเก็บรักษาข้อมูล</Box>
        <Box className="indent">
          7.1 ศูนย์ฝึกอบรมฯ จะเก็บรักษาข้อมูลต่างๆ ของผู้เข้ารับการอบรมฯ ภายใต้นโยบายความปลอดภัยตามนโยบายนี้
          ตลอดระยะเวลาเพื่อบรรลุวัตถุประสงค์ที่กำหนดในการเก็บสำหรับการให้บริการจัดอบรมหลักสูตรออนไลน์ฯ
          แก่ผู้เข้ารับการอบรมฯ และ/หรือนายจ้างหรือหน่วยงานต้นสังกัดฯ และ/หรือจนกว่าผู้เข้ารับการอบรมฯ
          จะแจ้งยกเลิกหรือเพิกถอนความยินยอมให้ศูนย์ฝึกอบรมฯ จัดเก็บข้อมูลใดๆ ตามวิธีการที่กำหนดไว้ในนโยบายนี้ เว้นแต่
          ศูนย์ฝึกอบรมฯ มีเหตุจำเป็นตามวัตถุประสงค์ กฎหมายคุ้มครองข้อมูลส่วนบุคคล
          รวมถึงกฎหมายที่เกี่ยวข้องจะกำหนดไว้เป็นอย่างอื่น
        </Box>
        <Box className="indent">
          โปรดทราบว่าหากผู้เข้ารับการอบรมฯ ไม่ให้ข้อมูลส่วนบุคคลไม่ว่าทั้งหมดหรือบางส่วนแก่ศูนย์ฝึกอบรมฯ
          อาจมีการให้บริการบางประเภทหรือทั้งหมดที่ศูนย์ฝึกอบรมฯ ไม่สามารถให้บริการแก่ผู้เข้ารับการอบรมฯ
          ได้หากปราศจากข้อมูลส่วนบุคคลของผู้เข้ารับการอบรมฯ ดังกล่าว
        </Box>
        <br />
        <Box className="indent">
          7.2 ศูนย์ฝึกอบรมฯ จะจัดเก็บข้อมูลต่างๆ ในลักษณะเอกสารหรือข้อมูลที่เก็บอยู่ในรูปแบบดิจิทัล (Soft Copy) และ/หรือ
          สำเนาเอกสาร (Hard Copy) ณ ที่ทำการหรือสถานที่ ศูนย์ฝึกอบรมฯ กำหนด รวมถึงอาจจัดเก็บในลักษณะ Cloud
        </Box>
      </Box>
      <Box className="paragraph">
        <Box className="bold">8. การใช้คุกกี้โดยบุคคลภายนอก และเทคโนโลยีการติดตามอื่น</Box>
        <Box className="indent">
          เนื้อหา และแอพพลิเคชั่นในบางส่วน รวมถึงโฆษณาบนระบบการให้บริการจัดอบรมหลักสูตรออนไลน์ฯ ของศูนย์ฝึกอบรมฯ นั้น
          อาจดำเนินการโดยบุคคลภายนอก อาทิ ผู้โฆษณา เครือข่ายโฆษณา (ad networks) และเซอร์เวอร์ ผู้ให้บริการเนื้อหา
          และผู้ให้บริการแอพพลิเคชั่น ซึ่งบุคคลภายนอกเหล่านี้อาจใช้คุกกี้เพียงอย่างเดียว หรือใช้ร่วมกับเว็บ บีคอนส์
          หรือเทคโนโลยีการติดตามอื่น ในการเก็บรวบรวมข้อมูลซึ่งอาจเกี่ยวโยงกับข้อมูลส่วนบุคคลของผู้เข้ารับการอบรมฯ
          เพื่อจัดหาโฆษณาซึ่งตรงกับความสนใจ (เชิงพฤติกรรม) ของผู้เข้ารับการอบรมฯ เมื่อผู้เข้ารับการอบรมฯ
          ดังกล่าวใช้ระบบการให้บริการจัดอบรมหลักสูตรออนไลน์ฯ
        </Box>
        <Box className="indent">
          หากผู้เข้ารับการอบรมฯ มีคำถามเกี่ยวกับการโฆษณา หรือเนื้อหาที่น่าสนใจอื่นๆ ผู้เข้ารับการอบรมฯ
          ควรติดต่อกับบุคคลภายนอกดังกล่าววซึ่งรับผิดชอบโดยตรง
        </Box>
      </Box>
      <Box className="paragraph">
        <Box className="bold">9. การรับรอง</Box>
        <Box className="indent">
          ข้อมูลส่วนบุคคลของผู้เข้ารับการอบรมฯ จะถูกนำมาประมวลผลโดยจำกัดเท่าที่จำเป็น
          และจะเป็นไปโดยชอบด้วยกฎหมายคุ้มครองข้อมูลส่วนบุคคล มีความเป็นธรรม และโปร่งใส
          และจะไม่ถูกประมวลผลต่อไปในลักษณะที่ไม่สอดคล้องกับวัตถุประสงค์ที่ได้กล่าวไว้
        </Box>
      </Box>
      <Box className="paragraph">
        <Box className="bold">10. สิทธิของเจ้าของข้อมูลส่วนบุคคล</Box>
        <Box className="indent">ภายใต้กฎหมายคุ้มครองข้อมูลส่วนบุคคล ผู้เข้ารับการอบรมฯ มิสิทธิต่างๆ ดังนี้</Box>
        <Box className="indent bold">10.1 สิทธิในการเพิกถอนความยินยอม (Right to withdraw consent)</Box>
        <Box className="indent">
          ผู้เข้ารับการอบรมฯ มีสิทธิในการเพิกถอนความยินยอมในการประมวลผลข้อมูลส่วนบุคคลที่ผู้เข้ารับการอบรมฯ
          ได้ให้ความยินยอมไว้กับศูนย์ฝึกอบรมฯ ตลอดระยะเวลาที่ข้อมูลส่วนบุคคลถูกเก็บไว้กับศูนย์ฝึกอบรมฯ
        </Box>
        <Box className="indent bold">10.2 สิทธิในการเข้าถึงข้อมูล (Right to Access)</Box>
        <Box className="indent">
          ผู้เข้ารับการอบรมฯ มีสิทธิในการเข้าถึงและขอรับสำเนาข้อมูลส่วนบุคคล
          และการขอให้เปิดเผยการได้มาซึ่งข้อมูลส่วนบุคคล โดยศูนย์ฝึกอบรมฯ จะดำเนินการแจ้งให้ทราบภายใน 30 วัน
          นับตั้งแต่วันที่ได้รับแจ้ง เว้นแต่ศูนย์ฝึกอบรมฯ กำหนดเป็นอย่างอื่น
        </Box>
        <Box className="indent bold">10.3 สิทธิในการแก้ไขให้ถูกต้อง (Right to Rectification)</Box>
        <Box className="indent">
          ผู้เข้ารับการอบรมฯ มีสิทธิที่จะได้รับการแก้ไขข้อมูลให้ถูกต้องและเป็นปัจจุบันได้ตลอดระยะเวลา
        </Box>
        <Box className="indent bold">
          10.4 สิทธิในการขอให้ลบหรือทำลายข้อมูลส่วนบุคคล (สิทธิที่จะถูกลืม) (Right to Erasure)
        </Box>
        <Box className="indent">
          ผู้เข้ารับการอบรมฯ มีสิทธิที่จะได้รับการลบหรือทำลายข้อมูลส่วนบุคคลของผู้เข้ารับการอบรมฯ จากศูนย์ฝึกอบรมฯ
          ในกรณีที่ข้อมูลส่วนบุคคลนั้นไม่มีความจำเป็นเกี่ยวข้องต่อวัตถุประสงค์ที่ถูกจัดเก็บหรือประมวลผลอีกต่อไป
          หรือผู้เข้ารับการอบรมฯ ประสงค์ให้ถอนความยินยอมหรือใช้สิทธิคัดค้าน
          หรือกรณีที่ข้อมูลส่วนบุคคลถูกประมวลโดยไม่ชอบด้วยกฎหมาย
        </Box>
        <Box className="indent">
          โปรดทราบว่าหากผู้เข้ารับการอบรมฯ ใช้สิทธิในการขอให้ลบหรือทำลายข้อมูลส่วนบุคคล
          อาจมีการให้บริการบางประเภทหรือทั้งหมดที่ศูนย์ฝึกอบรมฯ ไม่สามารถให้บริการแก่ผู้เข้ารับการอบรมฯ ได้
          หากปราศจากข้อมูลส่วนบุคคลของผู้เข้ารับการอบรมฯ ดังกล่าว ทั้งนี้ ศูนย์ฝึกอบรมฯ
          ขอสงวนสิทธิในการปฏิเสธการลบหรือทำลายข้อมูล หากข้อมูลดังกล่าวนั้น ศูนย์ฝึกอบรมฯ มีหน้าที่จะต้องเก็บ รวบรวม
          และเปิดเผยตามที่กฎหมายกำหนด หรือมีเหตุจำเป็นต่อการให้บริการจัดอบรมแก่ผู้เข้ารับการอบรมฯ
        </Box>
        <Box className="indent bold">10.5 สิทธิในการถ่ายโอนข้อมูล (Right to Data Portability)</Box>
        <Box className="indent">
          ผู้เข้ารับการอบรมฯ มีสิทธิที่จะได้รับของมูลของผู้เข้ารับการอบรมฯ ที่ได้ให้ไว้กับศูนย์ฝึกอบรมฯ
          และมีสิทธิที่จะให้ศูนย์ฝึกอบรมฯ ถ่ายโอนข้อมูลไปยังบุคคลอื่นๆ ภายใต้เงื่อนไขที่ศูนย์ฝึกอบรมฯ กำหนด
        </Box>
        <Box className="indent">
          หมายเหตุ: ศูนย์ฝึกอบรมฯ จะไม่รับผิดชอบต่อความปลอดภัยของข้อมูลซึ่งได้ถูกส่งต่อให้แก่บุคคลอื่น
        </Box>
        <Box className="indent bold">
          10.6 สิทธิในการคัดค้าน (Right to Object) หรือระงับในการเก็บรวบรวม ใช้และเปิดเผยข้อมูลส่วนบุคคล (Right to
          Restriction of Processing)
        </Box>
        <Box className="indent">
          • ผู้เข้ารับการอบรมฯ มีสิทธิที่จะคัดค้านหรือระงับในการเก็บรวบรวม ใช้และเปิดเผยข้อมูลส่วนบุคคล
          และประมวลผลข้อมูลของผู้เข้ารับการอบรมฯ ไม่ว่าเวลาใดๆ ตลอดระยะเวลาที่ ศูนย์ฝึกอบรมฯ
          เก็บและประมวลผลข้อมูลส่วนบุคคลของผู้เข้ารับการอบรมฯ
        </Box>
        <Box className="indent">
          • ในกรณีที่ข้อมูลของผู้เข้ารับการอบรมฯ ถูกประมวลผลเพื่อวัตถุประสงค์ในการตลาดทางตรง ผู้เข้ารับการอบรมฯ
          มีสิทธิที่จะคัดค้านการประมวลผลเพื่อการตลาดนั้น
          รวมถึงการรวบรวมข้อมูลโดยละเอียดซึ่งเกี่ยวข้องต่อการตลาดทางตรงนั้น ๆ
        </Box>
        <Box className="indent">
          • ทั้งนี้ อาจมีบางการให้บริการที่ศูนย์ฝึกอบรมฯ ไม่สามารถให้บริการแก่ผู้เข้ารับการอบรมฯ
          ได้หากปราศจากความยินยอมของผู้เข้ารับการอบรมฯ โดยศูนย์ฝึกอบรมฯ
          จะแจ้งให้ทราบถึงผลของการเพิกถอนความยินยอมภายหลังจากที่ศูนย์ฝึกอบรมฯ ได้รับคำร้องขอเพิกถอน
        </Box>
        <br />
        <Box className="indent">
          อนึ่ง ศูนย์ฝึกอบรมฯ สงวนสิทธิในการปฏิเสธการคัดค้านการเก็บรวบรวม
          ใช้และเปิดเผยข้อมูลส่วนบุคคลหากข้อมูลดังกล่าวนั้น ศูนย์ฝึกอบรมฯ มีหน้าที่จะต้องเก็บ รวบรวม
          และเปิดเผยตามที่กฎหมายกำหนด หรือมีเหตุจำเป็นต่อการให้บริการจัดอบรมแก่ผู้เข้ารับการอบรมฯ
        </Box>
        <Box className="indent">
          ด้วยเหตุข้างต้น ศูนย์ฝึกอบรมฯ จึงอาจปฎิเสธคำร้องของท่านโดยให้เหตุผลที่กฎหมายกำหนด
          รวมทั้งของสงวนสิทธิในการพิจารณาคำร้องขอท่านภายใต้เงื่อนไข กระบวนการ และกฎระเบียบของศูนย์ฝึกอบรมฯ
          หรือจำเป็นต่อการปฎิบัติตามสัญญาหรือการให้บริการจัดอบรมหลักสูตรออนไลน์ฯ โดย ศูนย์ฝึกอบรมฯ จะแจ้งให้ท่านทราบ
        </Box>
      </Box>
      <Box className="paragraph">
        <Box className="bold">11. การปรับปรุงนโยบายคุ้มครองข้อมูลส่วนบุคคล</Box>
        <Box className="indent">
          ศูนย์ฝึกอบรมฯ อาจทำการปรับปรุง
          แก้ไขเพิ่มเติมเงื่อนไขและข้อกำหนดของนโยบายคุ้มครองข้อมูลส่วนบุคคลนี้เป็นครั้งคราว
          ซึ่งการแก้ไขเพิ่มเติมดังกล่าวถือว่าเป็นส่วนหนึ่งของนโยบายและข้อกำหนดในนโยบายคุ้มครองข้อมูลส่วนบุคคลนี้ด้วย
        </Box>
        <Box className="indent">
          ผู้เข้ารับการอบรมฯ
          จะได้รับการแจ้งให้ทราบหากมีการการปรับปรุงหรือแก้ไขส่วนสำคัญในนโยบายคุ้มครองข้อมูลส่วนบุคคลนี้ โดยศูนย์ฝึกอบรมฯ
          จะระบุบนเว็บไซต์ในกรณีที่มีการปรับปรุงแก้ไขนโยบายก่อนที่การปรับปรุงดังกล่าวจะมีผลบังคับ
        </Box>
      </Box>
      <Box className="paragraph">
        <Box className="bold">12. มาตรการในการรักษาความมั่นคงปลอดภัยข้อมูลส่วนบุคคล</Box>
        <Box className="indent">
          ศูนย์ฝึกอบรมฯ กำหนดให้มีมาตรการรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคลที่เหมาะสม เพื่อป้องกันการ สูญหาย
          การเข้าถึง การใช้ การเปลี่ยนแปลง การแก้ไข
          หรือการเปิดเผยข้อมูลส่วนบุคคลโดยไม่มีอำนาจหรือโดยขัดต่อกฎหมายซึ่งสอดคล้องกับนโยบายนี้และวิธีปฏิบัติด้านความมั่นคงปลอดภัยสารสนเทศของศูนย์ฝึกอบรมฯ
          นอกจากนี้ ศูนย์ฝึกอบรมฯ จำกัดคนเข้าถึงข้อมูลส่วนบุคคลไว้สำหรับพนักงาน ลูกจ้าง
          ที่จำเป็นต้องทราบข้อมูลนั้นเพื่อทำการประมวลผลข้อมูลให้โดยที่บุคคลเหล่านั้นต้องปฏิบัติตามข้อกำหนดการรักษาข้อมูลที่เป็นความลับอย่างเข้มงวด
        </Box>
        <Box className="indent">
          ทั้งนี้ นโยบายและกฎระเบียบเกี่ยวกับมาตรการรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคล ศูนย์ฝึกอบรมฯ
          อาจมีการกำหนดเงื่อนไขเพิ่มเติมต่อไป
        </Box>
      </Box>
      <Box className="paragraph">
        <Box className="bold">13. การติดต่อกับ ศูนย์ฝึกอบรมฯ</Box>
        <Box className="indent">
          หากผู้เข้ารับการอบรมฯ ต้องการปรับเปลี่ยน เพิกถอน การไม่ให้ความยินยอม หรือการใช้สิทธิใดๆ ตามที่นโยบายนี้กำหนด
          รวมถึงหากผู้เข้ารับการอบรมฯ มีคำถาม หรือข้อแนะนำติชมใดๆ เกี่ยวกับข้อกำหนดความเป็นส่วนตัว
          หรือการบังคับใช้นโยบายดังกล่าว โปรดติดต่อที่
        </Box>
        <br />
        <Box className="bold">บริษัท สกิลเลน เอดูเคชั่น จำกัด</Box>
        <Box>เศรษฐีวรรณทาวเวอร์ ชั้น 1</Box>
        <Box>139 ถนนปั้น แขวงสีลม เขตบางรัก กรุงเทพมหานคร 10500</Box>
        <Box>
          โทรศัพท์:{' '}
          <NextLink color="#3155FF" underline="always" href="tel:028215524">
            02-821-5524
          </NextLink>
        </Box>
        <Box>
          อีเมล :{' '}
          <NextLink color="#3155FF" underline="always" href="mailto:cpd.info@skilllane.com">
            cpd.info@skilllane.com
          </NextLink>
        </Box>
        <Box>วันที่แก้ไขล่าสุด วันที่ 25 พฤษภาคม พ.ศ. 2565</Box>
      </Box>
    </Box>
  </PrivacyPolicyStyle>
);

export default PrivacyPolicy;
